import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Form, Input } from 'antd';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  return {
    name: Form.createFormField({ value: dataSource.name }),
    active: Form.createFormField({ value: dataSource.active })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, checkboxFormItemLayout, form, dataSource, inputFormItemLayout
}) => {
  const { getFieldDecorator } = form;
  const { name, active, is_integration_managed } = dataSource;
  const readonly = !canAdmin || is_integration_managed;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Name">
        {
          getFieldDecorator('name', {
            initialValue: name,
            rules: [{
              required: true,
              message: 'Please enter the Competency Type name.'
            }]
          })(<Input disabled={readonly} />)
        }
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('active', {
            initialValue: active,
            valuePropName: 'checked'
          })(
            <Checkbox disabled={readonly}>
              Active
            </Checkbox>
          )
        }
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('is_integration_managed', {
            initialValue: is_integration_managed,
            valuePropName: 'checked'
          })(
            <Checkbox disabled>
              Managed in Success Factors
            </Checkbox>
          )
        }
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const CompetencyTypeFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default CompetencyTypeFormInput;
